import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the surveysImport state domain
 */

const selectSurveysImportDomain = (state) =>
  state.get("surveysImport", initialState)

/**
 * Other specific selectors
 */

/**
 * Default selector used by SurveysImport
 */

const makeSelectSurveysImport = () =>
  createSelector(selectSurveysImportDomain, (substate) => substate.toJS())

export const makeSelectIsDownloading = () =>
  createSelector(selectSurveysImportDomain, (state) =>
    state.get("isDownloading")
  )

export const makeSelectIsUploading = () =>
  createSelector(selectSurveysImportDomain, (state) => state.get("isUploading"))

export const makeSelectPercentage = () =>
  createSelector(selectSurveysImportDomain, (state) => state.get("percentage"))

export const makeSelectSummaryData = () =>
  createSelector(selectSurveysImportDomain, (state) => state.get("summaryData"))

export const makeSelectSummaryHas = () =>
  createSelector(selectSurveysImportDomain, (state) => state.get("hasSummary"))

export const makeSelectSurveyData = () =>
  createSelector(selectSurveysImportDomain, (state) => state.get("surveyData"))

export const makeSelectIsData = () =>
  createSelector(selectSurveysImportDomain, (state) => state.get("isData"))
export const makeSelectIsLoading = () =>
  createSelector(selectSurveysImportDomain, (state) => state.get("isLoading"))

export default makeSelectSurveysImport
export { selectSurveysImportDomain }
